export enum API_ERROR_META_CODE {
  UNAUTHORIZED = '40101',
  OFFICE_NOT_SELECTED = '40102',
  OFFICE_EXPIRED = '40103',
  TERM_OF_USE_NOT_CONFIRMED = '40301',
  JOURNAL_SENDING_IN_PROCESS = '40001',
}

export enum API_STATUS_CODE {
  OK = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  UNPROCESSABLE_ENTITY = 422,
  SERVER_ERROR = 500,
  SERVICE_UNAVAILABLE = 503,
}

export enum ERROR_CODES {
  ERR_DELETE_DATA_IN_USE = 'ERR_DELETE_DATA_IN_USE',
  ERR_NOT_INTEGRAL_DATA_RELATION = 'ERR_NOT_INTEGRAL_DATA_RELATION',
  ERR_EXCISE_NOT_VALID_AT_TIME = 'ERR_EXCISE_NOT_VALID_AT_TIME',
  ERR_ACCOUNT_ITEM_DISABLED = 'ERR_ACCOUNT_ITEM_DISABLED',
  ERR_ACCOUNT_SUB_ITEM_DISABLED = 'ERR_ACCOUNT_SUB_ITEM_DISABLED',
  ERR_PLAN_LIMIT_EXCEEDED = 'ERR_PLAN_LIMIT_EXCEEDED',
  ERR_INVALID_ACQUISITION_COST_PETTY_SUM_METHOD = 'ERR_INVALID_ACQUISITION_COST_PETTY_SUM_METHOD',
  ERR_INVALID_ACQUISITION_COST_PETTY_SUM_METHOD_400K = 'ERR_INVALID_ACQUISITION_COST_PETTY_SUM_METHOD_400K',
}
